import { render } from "./SlackEmojiPicker.vue?vue&type=template&id=54e10ae7"
import script from "./SlackEmojiPicker.vue?vue&type=script&lang=js"
export * from "./SlackEmojiPicker.vue?vue&type=script&lang=js"

import "./SlackEmojiPicker.vue?vue&type=style&index=0&id=54e10ae7&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__